import { render, staticRenderFns } from "./LockRatioOnIcon.vue?vue&type=template&id=53e7af89&"
import script from "./LockRatioOnIcon.vue?vue&type=script&lang=js&"
export * from "./LockRatioOnIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports